module.exports = __webpack_public_path__ + "static/img/close.7c2a86f8.svg";